import { createContext, useEffect, useState } from "react";
import { Row, Col, Tabs, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArchive, faPlus, faTable } from "@fortawesome/pro-regular-svg-icons";

import { GET } from "../../../providers/useAxiosQuery";
import PageFacultyLoadContent from "./components/PageFacultyLoadContent";

export const PageFacultyLoadContext = createContext({});

export default function PageFacultyLoad(props) {
	const { moduleCode } = props;
	const [active, setActive] = useState("1");
	const [profileIds, setProfileIds] = useState([]);

	const { data: dataFaculty } = GET(
		`api/profile?roles=4,5,6,9&sort_field=fullname&sort_order=asc`,
		"profile_faculty_dropdown",
		() => {},
		false,
	);
	const { data: dataDepartments, refetch: refetchDepartments } = GET(
		`api/department_dropdown?sort_field=department_name&sort_order=asc&profileIds=${profileIds}`,
		"department_dropdown",
		() => {},
		false,
	);
	const { data: dataRooms } = GET(
		`api/room`,
		"room_selectss",
		(res) => {},
		false,
	);
	const { data: dataSchoolYear } = GET(
		`api/school_year?sort_field=sy_to&sort_order=asc`,
		"school_year_dropdown",
		() => {},
		false,
	);
	const { data: dataSemester } = GET(
		`api/semester?sort_field=semester&sort_order=asc`,
		"semester_dropdown",
		() => {},
		false,
	);

	useEffect(() => {
		refetchDepartments();

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [profileIds]);

	const items = [
		{
			key: "0",
			// icon: <FontAwesomeIcon icon={faPlus} />,
			label: (
				<>
					<Button
						type="text"
						icon={<FontAwesomeIcon icon={faPlus} />}
						className="tab_btn_add"
					>
						Add Faculty Load
					</Button>
				</>
			),
			children: null,
			disabled: true,
		},
		{
			key: "1",
			icon: <FontAwesomeIcon icon={faTable} />,
			label: "Faculty Load",
			children: <PageFacultyLoadContent isTrash={0} />,
		},
		{
			key: "2",
			icon: <FontAwesomeIcon icon={faArchive} />,
			label: "Faculty Load Archive",
			children: <PageFacultyLoadContent isTrash={1} />,
		},
	];

	return (
		<PageFacultyLoadContext.Provider
			value={{
				moduleCode,
				dataFaculty,
				dataDepartments,
				dataRooms,
				dataSchoolYear,
				dataSemester,
				profileIds,
				setProfileIds,
			}}
		>
			<Row gutter={[20, 0]}>
				<Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
					<Tabs
						defaultActiveKey="1"
						indicator={{
							size: (origin) => origin - 25,
							align: "end",
						}}
						items={items.map((item) => ({
							...item,
							children: null,
						}))}
						onChange={(e) => {
							if (e !== "0") {
								setActive(e);
							}
						}}
					/>
				</Col>
				<Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
					{items[active]?.children}
				</Col>
			</Row>
		</PageFacultyLoadContext.Provider>
	);
}
